<template>
  <div class="empty">
    <div class="top">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bf41fa93318d5c612785ca3677f88105.png"
        alt=""
      />
      <div class="text">没有找到与「{{ searchValue }}」相关的补剂哦</div>
      <div class="consult" @click="bindJump"
        ><span>找营养师添加</span><span class="iconfont icon-you"></span
      ></div>
    </div>
    <SearchHot @search="bindSearch" />
  </div>
</template>

<script>
import { jumpToMiniProgram } from '../data.js'
import SearchHot from './search-hot.vue'
export default {
  components: {
    SearchHot
  },
  props: {
    hot: {
      type: Array,
      default: () => []
    }
  },
  inject: ['getSearchValue'],
  data() {
    return {}
  },
  computed: {
    searchValue() {
      return this.getSearchValue()
    }
  },
  created() {},
  methods: {
    bindSearch(item) {
      this.$emit('search', item)
    },
    bindJump() {
      jumpToMiniProgram()
    }
  }
}
</script>
<style lang="scss" scoped>
.empty {
  padding: 16px;

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    .image {
      width: 160px;
      height: 84px;
      margin-bottom: 20px;
    }

    .text {
      font-size: 12px;
      color: rgba(51, 51, 51, 0.5);
      line-height: 17px;
      margin-bottom: 7px;
    }

    .consult {
      font-weight: bold;
      font-size: 12px;
      color: #00cddf;
      line-height: 20px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
